import React, { useCallback, useState } from 'react';
import { Dropdown } from 'antd';

const defaultTrigger = ['click'];

const ControlledDropdown = ({
  renderOverlay,
  renderButton,
  trigger = defaultTrigger,
  placement = 'bottomRight',
  ...props
}) => {
  const [visible, setVisible] = useState(false);

  const close = useCallback(() => setVisible(false), []);

  return (
    <Dropdown
      onVisibleChange={setVisible}
      visible={visible}
      trigger={trigger}
      overlay={renderOverlay({ onClose: close })}
      placement={placement}
      {...props}
    >
      {renderButton({ visible })}
    </Dropdown>
  );
};

export default ControlledDropdown;
